<template>
    <div class="assign-article-modal">
        <ModalContainer :title="$t('blinds.add_article')" identifier="assign-article-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputSelect v-model="$v.article.$model" identifier="article"
                                 :label="$t('blinds.article')" :options="articleOptions"
                                 :placeholder="$t('blinds.article')" :disabled="is_saving"
                                 :has-error="$v.article.$error" track-by="id"
                                 :display-custom-label="(row) => `${row.attributes.name} - ${row.attributes.code}${row.relationships.category && row.relationships.category.data && row.relationships.category.data.attributes && row.relationships.category.data.attributes.name ? `, ${row.relationships.category.data.attributes.name}` : ''}`"
                                 class="select-container">
                    <template v-slot:errors>
                        <p v-if="!$v.article.required">
                            {{$t('validation.x_is_required',{x: $t('blinds.article')})}}
                        </p>
                    </template>
                </FormInputSelect>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('add')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
import _ from 'lodash';
import ModalContainer from "../modal/ModalContainer";
import Form from "../form/Form";
import FormInputText from "../form/FormInputText";
import FormGroupTwo from "../form/FormGroupTwo";
import FormInputSelect from "../form/FormInputSelect";
import FormInputTextSelect from "../form/FormInputTextSelect";
import {required, email} from 'vuelidate/lib/validators'
import Button from "../Button";
import FormInputPassword from "@/components/form/FormInputPassword";

export default {
    name: "AssignArticleModal",
    components: {FormInputPassword, Button, FormInputSelect, FormInputTextSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
    data() {
        return {
            article: null,
            articleOptions: [],
            is_loading_articles: false,
            is_saving: false
        }
    },
    validations: {
        article: {required}
    },
    methods: {
        close(status) {
            this.$modal.hide('assign-article-modal', status);
        },
        save() {
            this.$v.article.$touch();
            if (this.$v.article.$anyError || this.is_saving)
                return;

            this.is_saving = true;

            this.$axios.put(`blinds/${this.$route.params.id}/articles/${this.article.id}/attach`)
                .then(({data}) => {
                    this.is_saving = false;
                    this.close(true);
                })
                .catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data, this.$t('blinds.error_add_article')),
                        type: 'error',
                    });
                });
        },
        retrieveArticleOptions() {
            this.is_loading_articles = false;
            this.$axios.get('articles/list')
                .then(({data}) => {
                    this.articleOptions = data.data;
                    this.is_loading_articles = false;
                })
                .catch(e => {
                    this.is_loading_articles = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data, this.$t('blinds.error_retrieve_articles')),
                        type: 'error',
                    });
                });
        },
    },

    mounted() {
        this.retrieveArticleOptions();
    }
}
</script>

<style lang="scss">
    .checkbox-container {
        @apply flex flex-row mb-8 mt-2;

        .pretty {
            &:last-of-type {
                @apply ml-8;
            }
        }
    }
</style>
